const modalsUa = {
  requests: "Які запити розглянемо?",
  howIsGoingCons: "Як проходить консультація?",
  buy: "Купити",

  personal: {
    title: "Цілісна особиста матриця",

    firstStep:
      "Перший рівень Матриці Долі є ідеальною основою для початку в пізнанні себе та своїх глибинних процесів. Матриця відповідає на багато питань, таких як:",
    stepsList1: "Якими якостями я володію?",
    stepsList2: "Яке моє призначення?",
    stepsList3: "Які таланти у мене є?",
    stepsList4: "Як я можу реалізувати себе?",
    stepsList5: "Як заробити гроші?",
    stepsList6: "Як побудувати особисте життя?",
    stepsList7: "Куди піти навчатися?",
    stepsList8: "Чи можу я відкрити свій бізнес?",
    stepsList9: "Чому складні стосунки з рідними? Та інші.",
    desc1:
      "Матриця розкриє унікальні аспекти та таланти, що притаманні вашій особистості. Вона також виявить можливі виклики, випробування та негативні установки, що можуть бути спадковими з попередніх життів, але які можна перетворити на джерело сили та потенціалу.",
    desc2:
      "У майбутньому, саме ця основна інформація може бути розширена шляхом використання інших методів і підходів, що дозволять значно глибше вивчити свою особистість, а також виходити на нові рівні розуміння та свідомості.",
    desc3:
      "Це найглибша та найфундаментальніша трансформація у вашому житті, після якої життя розділяється на «до» та «після»",
    videoMeeting:
      "Відеозустріч до 3 годин + трансформація 60-90 днів за індивідуальною програмою",
    additionalInfo1: "+ Додатково входить розбір сумісності з 1 людиною",
    additionalInfo2: "*Процес зцілення може проходити через загострення.",
  },
  family: {
    title: "9 колін роду",
    desc1:
      "9 колін роду — другий рівень оригінального методу Матриці Долі. Якщо особиста Матриця допомагає зрозуміти себе й прийти до цілісності особистості, то родова відкриває наступний рівень — соціально-родове призначення, стосунки з родиною та реалізацію в соціумі.",
    desc2:
      "На цьому етапі ми індивідуально розраховуємо твої 9 колін роду, визначаємо родові ключі та програми й починаємо переводити їх із «мінуса» в «плюс» через практики та етичні дії.",
    desc3:
      "Робота допоможе:глибше пропрацювати Аркани та програми, які розкриваються на родовому рівні; побачити повторювані сімейні сценарії та змінити те, що більше не хочеться продовжувати; по-новому подивитися на батьків, близьких і стосунки всередині родини; розкрити ресурс свого коріння для проявлення, реалізації та руху до цілей; глибше зрозуміти своє соціально-родове призначення та місце серед інших людей; створити нові причини для сприятливих змін у своєму житті та наступних поколіннях.",
    desc4:
      "Родова Матриця не менш важлива, ніж особиста. Це можливість не лише глибше зрозуміти своє коріння, а й узяти з нього ресурс для наступного етапу життя — а іноді побачити приємні зміни навіть там, де довго нічого не зрушувалося.",
    videoMeeting: "Відеозустріч + трансформація протягом >110 днів",
    additionalInfo1:
      "*Велика кількість практик. Трансформації та зцілення можуть проходити через загострення",
  },
  awareness: {
    title: "Матриця усвідомленості",
    desc1:
      "«Матриця усвідомленості» — мій авторський формат поглибленої роботи з рідкісними розрахунками оригінального методу Матриці Долі. Він доступний тим, хто вже знайомий зі своєю цілісною особистою Матрицею, пропрацював її основні програми та готовий рухатися далі.",
    desc2:
      "Тут починається найцікавіше: розрахунки та рівні, які практично не зустрічаються у відкритих джерелах. Ми виходимо за межі звичної Матриці та досліджуємо глибші кармічні програми, внутрішні сценарії й додаткові грані твоїх Арканів. Деякі розрахунки ти вже міг бачити в моєму калькуляторі — тут ми нарешті детально розбираємо та пропрацьовуємо їх.",
    desc3:
      "Це формат для тих, кому вже замало просто знати свою Матрицю. Ти отримуєш можливість відкрити рідкісні рівні оригінального методу, глибше дослідити себе та застосувати отримані знання на практиці — а далі побачити, які зміни вони принесуть саме у твоє життя.",
    listTitle: "Які рівні входять:",
    listEl1: "Призначення і матриця усвідосленності;",
    listEl2: "Призначення і матриця внутрішньої карми;",
    listEl3: "Матриця кристалу душі;",
    listEl4: "Рівень «16 карм»;",
    listEl5: "Рівень «Демон — Жертва»",
    videoMeeting: "3 відеозустрічі + трансформація від 60 днів",
    additionalInfo1:
      "*Рівень доступний одразу після «Цілісної особистої матриці»",
  },
  prosperity: {
    title: "Зірка процвітання",
    desc1:
      "«Чого я насправді хочу?», «Яким я хочу бачити своє життя далі?», «І як перетворити свої бажання на реальні цілі та дії?»",
    desc2:
      "Зірка Процвітання — третій рівень оригінального методу Матриці Долі, присвячений бажанням, проявленості та матеріальній реалізації. Ми визначимо твої бажання та розрахуємо індивідуальну Зірку, щоб побачити:",
    desc3:
      "Цей рівень не лише про те, як отримати бажане, а й про внутрішню готовність до більшого — мріяти, створювати, проявлятися, приймати результати своїх дій і дозволяти собі процвітати.",
    listEl1:
      "як твої ідеї проходять шлях від думки й натхнення до дій і реальних результатів;",
    listEl2:
      "що може заважати тобі рухатися до бажаного та де виникають особисті перешкоди;",
    listEl3:
      "що допомагає або заважає тобі приймати більше й утримувати досягнуті результати;",
    listEl4:
      "як проявленість, визнання та стосунки з матеріальним розкриваються через твої Аркани;",
    listEl5:
      "які якості важливо перевести з «мінуса» в «плюс» і пропрацювати через практики.",
    videoMeeting: "Відеозустріч + трансформація протягом 60 днів",
    additionalInfo1: '* Доступно лише після проходження «9 колін роду»".',
    additionalInfo2: "* Включає велику кількість практичної роботи.",
  },
  conscience: {
    title: "Усвідомленість",
    desc1:
      "Ця консультація розкриває глибоку проблематику життя, приводить до нового рівня духовного розвитку. Розбір внутрішньої карми. Відкриття серцевої чакри, кристала душі та глибинних здібностей особистості.",
    desc2:
      "Цей розрахунок показує повний сценарій ситуацій у житті людини та кармічні історії, які проходимо. У результаті людина отримує діамантове ограновування матриці, тобто захист долі.",
    listTitle: "У склад входять розрахунки таких матриць:",
    listEl1: "матриця душі;",
    listEl2: "матриця внутрішньої карми;",
    listEl3: "матриця усвідомленості;",
    listEl4: "матриця брами світла.",
    videoMeeting: "Відеозустріч 90 хвилин + трансформація",
    additionalInfo1:
      "! Потребує мінімального знайомства з базовим рівнем власної матриці.",
    additionalInfo2:
      "!Містить у собі велику кількість практичної та ритуальної роботи. Процес зцілення може проходити через загострення.",
  },
  coupleTherapy: {
    title: "Парна терапія",
    desc1:
      "Діагностика стосунків з партнером (кохана людина, батьки, діти, друзі, знайомі, брати/сестри, колеги).",
    desc2:
      "Допомагає виявити цілі й проблеми комунікації; точки зростання; завдання партнерів; ресурсний стан. Робота з негативними й позитивними якостями кожного з партнерів; опрацювання чинників, які заважають гармонійній взаємодії партнерів; розбір плюсів і мінусів сумісності.",
    desc3:
      "+ Остаточні рекомендації для ефективного розв'язання проблем, досягнення загальних цілей і балансу в партнерстві за результатами терапії.",
    videoMeeting:
      "Особиста зустріч або відеозустріч від 3-х годин (1-2 перерви по 10 хвилин) + трансформація для партнерів",
    warning: "*Необхідна присутність обох партнерів!",
  },
  game: {
    title: 'Трансформаційна гра "Кармічні Подорожі"',
    desc1:
      "У грі можна дослідити практично будь-який життєвий запит через минуле, теперішнє й майбутнє та побачити неочевидні причинно-наслідкові зв’язки.",
    desc2:
      "Можна прийти з одним конкретним запитом, метою або дослідити одразу кілька сфер життя: стосунки, гроші, роботу й реалізацію, призначення, особистісний розвиток, повторювані ситуації та інші. Подивитися, що відбувається в кожній із них, і за потреби вчасно скоригувати свої дії.",
    listTitle: "Гра допомагає:",
    listEl1:
      "зрозуміти, чому виникла або повторюється ситуація та які причини до неї призвели;",
    listEl2: "побачити, чи ти зараз покращуєш її, чи продовжуєш погіршувати;",
    listEl3: "зрозуміти, що вже робиш правильно, а де помиляєшся;",
    listEl4:
      "визначити, що можна змінити, щоб ситуація вирішилася або ти наблизився до своєї мети;",
    listEl5:
      "побачити, які можливості для бажаного результату вже створені твоїми минулими діями.",
    listEl6:
      "подивитися на звичну ситуацію з іншого боку та помітити те, чого раніше не бачив;",
    listEl7: "отримати більше внутрішньої ясності та спокою щодо свого запиту.",

    videoMeeting: "Відеозустріч",
    meeting: "Зустріч у м. Бар, Чорногорія (узгоджується з учасниками)",
    person: "люд",
    groupGame: "Групова гра(до 6 учасників)",
    personalGame: "Індивідуальна гра",
  },
  parentChildren: {
    title: "Дитячо-батьківські відносини",
    listTitle: "Ця консультація допоможе:",
    listEl1: "розуміти себе і свою дитину;",
    listEl2: "побудувати правильну комунікацію;",
    listEl3: "звернути увагу на певні якості дитини;",
    listEl4: "спрямувати її у потрібну сферу діяльності;",
    listEl5: "ефективно вирішувати конфліктні ситуації;",
    listEl6: "вибрати певну модель поведінки для батьків;",
    listEl7: "виявити таланти, здібності, завдання та ключові енергії дитини.",
    videoMeeting:
      "Відеозустріч 60-90 хвилин + індивідуальні рекомендації для дитини та дитячо-батьківських взаємин + трансформація для одного з батьків з урахуванням запиту.",
    additionalInfo1: "Матриця дитини, Сумісність 1 з батьків з дитиною",
    additionalInfo2:
      "Комплексна консультація: Щаслива родина (матриця дитини, сумісність дитини з кожним з батьків, сумісність батьків)",
  },
  personalLife: {
    title: "Особисте життя",
    listTitle: "Ця консультація допоможе:",
    listEl1: "налагодити особисте життя;   ",
    listEl2: "знайти другу половинку;",
    listEl3: "зрозуміти, який тип взаємовідносин комфортний для вас;",
    listEl4: "досягти взаєморозуміння з партнером.",
    desc1:
      "Аналіз особистих якостей та причин, чому не вдається побудувати особисте життя. Розбір типажу партнера, що підходить, і які потреби важливо задовольняти у відносинах.",
    desc2:
      "Під час трансформації ви зможете посилити внутрішню енергетику, підвищити свою цінність та працювати над негативними сторонами, які заважають налагодити гармонійні взаємини.",
    desc3: "Аналіз матриці сумісності з 1-2 партнерами.",
    videoMeeting: "Відеозустріч 60 хвилин + трансформація 1 блок",
  },
  year: {
    title: "Прогноз на рік",
    desc1:
      "Дозволяє дізнатися про свої енергії в минулому, теперішньому чи майбутньому році. Містить в собі прогноз на кожні 22 дні, де описані всі ключові події цього періоду і надана варіативність як позитивних, так і негативних подій.",
    desc2:
      "Розкриття завдань, можливостей і випробувань цього року. Аспекти фінансів та особистого життя протягом року та можливості щодо їх позитивної реалізації.",
    videoMeeting:
      "Відеозустріч 40 хвилин + файл з прогнозом на кожні 22 дні + матеріали для гармонізації року на розсуд фахівця.",
    additionalInfo2:
      "*Можливість звернутися до фахівця за додатковими поясненнями та рекомендаціями протягом усього року.",
  },
};

export default modalsUa;
